export var BetTransactionStatusType;
(function (BetTransactionStatusType) {
    BetTransactionStatusType[BetTransactionStatusType["UNSETTLEMENT"] = 0] = "UNSETTLEMENT";
    BetTransactionStatusType[BetTransactionStatusType["SETTLEMENT"] = 1] = "SETTLEMENT";
})(BetTransactionStatusType || (BetTransactionStatusType = {}));
//# sourceMappingURL=BetTransactionStatusType.js.map